import { Typography } from "../Typography";
import CloseImage from "../../../assets/popup/close.svg";

export const SubscribeSuccessPopup = ({ onClose }) => {
  // DOWNLOAD SPREADSHEET FILE

  return (
    // <div classNameName="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
    //   <div classNameName="bg-beige-prim p-8 rounded-lg text-center max-w-md">
    //     <h2 classNameName="text-2xl font-bold mb-4">You're subscribed! 🎉</h2>
    //     <p>
    //       Please check your spam folder if you have not received my email in a
    //       few minutes.
    //     </p>

    //     <button
    //       classNameName="mt-4 bg-red-prim text-white px-6 py-2 rounded"
    //       onClick={onClose}
    //     >
    //       Close
    //     </button>
    //   </div>
    // </div>
    <div className="z-50 popup-background fixed top-0 w-[100vw] h-[100vh] bg-dark-sec bg-opacity-25">
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div
          style={{
            boxShadow: "12px 12px #ff3131",
          }}
          className="rounded-3xl popup-container max-w-[900px] bg-beige-prim flex flex-col items-center justify-center border-[3px] border-black pt-5 md:pt-10 pb-10 md:pb-14 px-5 md:px-10 text-center"
        >
          <button onClick={onClose} className="w-full">
            <img src={CloseImage} className="ml-auto w-10" />
          </button>
          <div className="flex flex-col items-center justify-start my-5">
            <Typography variant="h2">YOU'RE IN!</Typography>
            <Typography variant="">
              You've successfully subscribed to the Moneycessity Newsletter.
            </Typography>
            <Typography variant="">
              I've just sent you a confirmation email.
            </Typography>
            <Typography variant="">
              Please check your inbox in the next few minutes. If you don't see
              it, kindly check your spam or promotions folder.
            </Typography>
          </div>

          <button
            className="mt-4 bg-red-prim text-white px-6 py-2 rounded"
            onClick={onClose}
          >
            <Typography variant="">Close</Typography>
          </button>
        </div>
      </div>
    </div>
  );
};
